import SvgIcons from './SvgIcons';
import { ReactComponent as Error } from '../../assets/error.svg';

import { ReactComponent as EtherLogo } from '../../assets/ether_logo.svg';

export { Error, EtherLogo };

const Icons = SvgIcons;

export default Icons;
